import { apiRequest } from '@/lib/api'

export async function logUserInApp(pageName: string) {
  return apiRequest<{ ok: true }>('/app-logs/user-in-app', {
    method: 'POST',
    body: JSON.stringify({ pageName }),
  })
}
